
















































































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  meterCosts,
  deleteMeterCost,
  DeleteMeterCostReq,
  UpdateMeterCostReq,
  AddMeterCostReq,
  addMeterCost,
  updateMeterCost,
  holidaysDates,
  UpdateHolidayDateReq,
  updateHolidaysDate,
  AddHolidayDateReq,
  addHolidaysDate,
  deleteHolidaysDate,
  DeleteHolidayDateReq,
  GetHolidayReq,
} from "@/api/meterCost";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  MeterCost,
  RuleCost,
  HolidayDate,
  Company,
} from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { DeepCopy } from "../../utils/ObjectCopy";
import { DataDef } from "vue/types/options";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { ElForm } from "element-ui/types/form";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
  },
})
export default class Holiday extends Vue {
  private getHolidayReq: GetHolidayReq = <GetHolidayReq>{};
  private dialogAddOrUpdate = false;
  private dialogDelete = false;
  private list: HolidayDate[] = [];
  private listLoading: boolean = true;
  private dialogType = "edit"; //判断弹出层是添加还是编辑
  private total = 0;
  private dates: Date[] = [];
  private isSearch = false;
  private holidayDate: HolidayDate = <HolidayDate>{};
  private listQuery: GetHolidayReq = <GetHolidayReq>{
    page: 1,
    pageSize: 10,
  };
  public search() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }

  private queryCompanys: Company[] = [];
  private loading = false;
  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }
  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }
  public resetSearch() {
    this.getHolidayReq = <GetHolidayReq>{};
  }

  public async getList() {
    this.listLoading = true;
    let req: GetHolidayReq = <GetHolidayReq>{};
    if (this.isSearch) {
      req = this.getHolidayReq;
      req.page = this.listQuery.page;
      req.pageSize = this.listQuery.pageSize;
    } else {
      req = this.listQuery;
    }
    const res = await holidaysDates(req);
    if (res.code === ResCode.SUCCESS) {
      this.list = res.data.holidayDateData.list;
      this.total = res.data.holidayDateData.totalCount;
    }
    this.listLoading = false;
  }

  public clickAddBtn(scope) {
    this.dialogType = "new";
    this.dialogAddOrUpdate = true;
    this.holidayDate = <HolidayDate>{};
  }
  public clickDeleteBtn(scope) {
    this.dialogDelete = true;
    this.holidayDate = <HolidayDate>DeepCopy(scope.row);
  }
  public clickUpdateBtn(scope) {
    this.dialogType = "edit";
    this.dialogAddOrUpdate = true;
    this.holidayDate = Object.assign({}, scope.row);
    let ss = this.holidayDate.dates.split(",");
    this.dates = [];
    for (let s of ss) {
      this.dates.push(new Date(s));
    }
  }
  public dataRules = {
    name: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    dates: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
  };

  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }
  private onDatePickerChange() {
    console.log(this.dates);
    console.log(this.holidayDate);
    if (!this.holidayDate.name) {
      this.$message.error(this.$t("notification.pleaseInputName").toString());
      return;
    }
    if (!this.dates || this.dates.length <= 0) {
      this.$message.error(
        this.$t("notification.pleasePickOneDateAtLeast").toString()
      );
      return;
    }
    let ss: string = "";
    for (let date of this.dates) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let s = y + "-" + m + "-" + d;
      if (ss === "") {
        ss = s;
      } else {
        ss = ss + "," + s;
      }
    }
    this.holidayDate.dates = ss;
  }
  public addOrUpdateMeterCost() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.updateMeterCost();
      } else {
        return false;
      }
    });
  }

  public async createMeterCost() {
    const res = await addHolidaysDate(<AddHolidayDateReq>{
      holidayDate: this.holidayDate,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogAddOrUpdate = false;
      this.getList();
    }
  }

  public async updateMeterCost() {
    const res = await updateHolidaysDate(<UpdateHolidayDateReq>{
      holidayDate: this.holidayDate,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogAddOrUpdate = false;
      this.getList();
    }
  }

  public async deleteMeterCost() {
    const res = await deleteHolidaysDate(<DeleteHolidayDateReq>{
      holidayDateID: this.holidayDate.id,
    });
    if (res && res.code === ResCode.SUCCESS) {
      this.dialogDelete = false;
      this.getList();
    }
  }

  private created() {
    this.getList();
  }
}
